import store from './store';
import app from './app';

const cacheMap = new Map();

function createKey(query, variables) {
  return `${query.replace(/\s+/g, '')}_${JSON.stringify(variables)}`;
}

// eslint-disable-next-line no-unused-vars
const FIRST = 20;

function gql({ query, variables, enableCache, clearCache, fragments }) {
  let key;
  if (enableCache && !clearCache) {
    key = createKey(query, variables);
    if (cacheMap.has(key)) return cacheMap.get(key);
  }

  let innerQuery = query;
  if (fragments) {
    innerQuery = fragments.join(' ') + query;
  }

  innerQuery = innerQuery.replace(/\s+/g, ' ').trim();

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  // add authentication header to request
  const idToken = store.getters['app/idToken'];
  if (idToken) headers.Authentication = `Bearer ${idToken}`;

  const fetchData = fetch(`${process.env.VUE_APP_SERVER_URL}`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ query: innerQuery, variables }),
  })
    .then(r => r.json())
    .then(({ data, errors }) => {
      if (errors) throw errors;
      return data;
    })
    .catch(err => {
      let errMsg = err.message;
      if (!errMsg && err[0] && err[0].message) errMsg = err[0].message;
      if (errMsg) app.getVue().$toastr.e(errMsg, 'gql error');
      throw err;
    });

  if (enableCache) {
    if (!key) key = createKey(query, variables);
    cacheMap.set(key, fetchData);
  }

  return fetchData;
}

export default {
  gql,
};
